var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"advertiser-response-content"},[_c('div',[_vm._v(_vm._s(_vm.response))]),_vm._v(" "),_c('div',{staticClass:"response-submission-date"},[_c('p',[_vm._v("Submission Date"),_c('br'),_vm._v(_vm._s(_vm.formatDate(_vm.submissionTime)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }